"use client";

import { useEffect, useState } from "react";
import { getInsightsApi } from "../../utils/get-insights";

type ExcessConsumption = {
  package: number | null;
  surplus: number | null;
  percentage: number | null;
};

type UseExcessConsumptionProps = {
  startDate: string;
  endDate: string;
  companyId: number;
};

export function useExcessConsumption({
  startDate,
  endDate,
  companyId,
}: UseExcessConsumptionProps) {
  const [data, setData] = useState<ExcessConsumption>();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!startDate || !endDate || !companyId) {
      return;
    }

    const fetchData = async () => {
      try {
        setIsLoading(true);

        const response = await getInsightsApi(
          "/package-consumption-plus-surplus",
          startDate,
          endDate,
          12000,
          companyId.toString(),
        );

        setData(response);
      } catch (error) {
        console.error("Erro ao buscar dados de distribuição por dia:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [startDate, endDate, companyId]);

  return { data, isLoading };
}
